/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { min, max } from 'lodash';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethodsV25, PaymentOptionsMetadata, Quote, Vehicle } from '@sm360/widget-commons-vehicle';
import { AdobeService, ADOBE_TAGS, AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';

import PurchaseMethodsTabControlHeader from 'payment-calculator-v25/components/PurchaseMethodsTabControl/PurchaseMethodsTabControlHeader.jsx';
import PaymentCalculatorDetails from 'payment-calculator-v25/components/PaymentCalculatorDetails/PaymentCalculatorDetails.jsx';

import * as Actions from 'payment-calculator-v25/actions/paymentCalculatorActions.js';
import PaymentBar from 'payment-calculator-v25/components/PaymentBar/PaymentBar.jsx';

const { PurchaseMethodsConstantV25 } = PurchaseMethodsV25;
class PaymentCalculatorDisplay extends React.Component {
    constructor(props) {
        super(props);
        this.setScrollTopToZero = this.setScrollTopToZero.bind(this);
        this.selectPurchaseMethod = this.selectPurchaseMethod.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.calculator = this.setScrollTopToZero(this.props, newProps, this.calculator);
    }

    setScrollTopToZero(oldProps, newProps, calculator) {
        const newCalculator = { ...calculator };
        if (!oldProps.frequenciesPanelOpen && newProps.frequenciesPanelOpen && calculator) {
            newCalculator.scrollTop = 0;
        }
        return newCalculator;
    }

    selectPurchaseMethod(selectedPurchaseMethod) {
        let selectedTerm = '';
        let selectedPaymentFrequency = '';
        let selectedKmPerYearPlan = '';
        let selectedCashDown = 0;
        let selectedFinancePlan = '';

        if ([PurchaseMethodsConstantV25.LEASE, PurchaseMethodsConstantV25.FINANCE].includes(selectedPurchaseMethod)) {
            if (this.props.hasAdobeTagging === true) {
                AdobeService.eventTrigger(
                    ADOBE_TAGS.VDP_ACTIONS(
                        this.props.quote?.vehicle?.vehicleCondition,
                        `payment calculator:${selectedPurchaseMethod}`,
                        {
                            make: this.props.quote?.vehicle?.make?.name,
                            model: this.props.quote?.vehicle?.model?.name,
                        },
                        this.props.vehicle?.commercialVehicle
                    ),
                    'global-onclick'
                );
            }
            AnalyticsService.ga4Trigger(
                TAGS.PAYMENT_CALCULATOR_TYPE(
                    selectedPurchaseMethod,
                    this.props.quote.vehicle.model.name,
                    this.props.quote.vehicle.year
                )
            );
            const { purchaseMethods, paymentOptionsMetadata } = this.props;
            const { financeOptions } = purchaseMethods;
            const { terms, paymentFrequencies, kmPerYearPlans } =
                paymentOptionsMetadata.find(
                    (option) => option.isAvailable && option.purchaseMethod === selectedPurchaseMethod
                ) || {};
            // Get finance or lease option based on selected purchase method
            const selectedFinanceOption = purchaseMethods?.getCalculatorFinanceLeaseOptions(selectedPurchaseMethod);
            const {
                selectedTerm: prevSelectedTerm,
                paymentFrequency,
                selectedCashDown: prevSelectedCashDown,
                kmPerYearPlan,
                financePlan,
            } =
                selectedFinanceOption || {};
            // Get previously selected term, frequency, km per year plan and cash down if available
            // Or choose the min of terms, frequency and km year plan
            selectedTerm = prevSelectedTerm > 0 ? prevSelectedTerm : min(terms);
            selectedPaymentFrequency = paymentFrequency > 0 ? paymentFrequency : min(paymentFrequencies);
            selectedKmPerYearPlan = kmPerYearPlan > 0 ? kmPerYearPlan : min(kmPerYearPlans);
            selectedCashDown = prevSelectedCashDown;
            selectedFinancePlan = financePlan;
        } else if (selectedPurchaseMethod === PurchaseMethodsConstantV25.CASH) {
            if (this.props.hasAdobeTagging) {
                AdobeService.eventTrigger(
                    ADOBE_TAGS.VDP_ACTIONS(
                        this.props.quote?.vehicle?.vehicleCondition,
                        `payment calculator:purchase price`,
                        {
                            make: this.props.quote?.vehicle?.make?.name,
                            model: this.props.quote?.vehicle?.model?.name,
                        },
                        this.props.vehicle?.commercialVehicle
                    ),
                    'global-onclick'
                );
            }
            AnalyticsService.ga4Trigger(
                TAGS.PAYMENT_CALCULATOR_TYPE(
                    selectedPurchaseMethod,
                    this.props.quote.vehicle.model.name,
                    this.props.quote.vehicle.year
                )
            );
            const { purchaseMethods } = this.props;
            selectedCashDown = purchaseMethods.cashDown;
        }
        this.props.actions.selectPurchaseMethod(
            selectedPurchaseMethod,
            selectedTerm,
            selectedPaymentFrequency,
            selectedKmPerYearPlan,
            selectedCashDown,
            selectedFinancePlan,
            this.props.config
        );
    }

    render() {
        const { purchaseMethods, paymentOptionsMetadata } = this.props;

        const calculatorLeaseOptionsAvailable = paymentOptionsMetadata.find(
            (meta) => meta?.isAvailable && meta?.purchaseMethod === PurchaseMethodsConstantV25.LEASE
        );
        const calculatorFinanceOptionsAvailable = paymentOptionsMetadata.find(
            (meta) => meta?.isAvailable && meta?.purchaseMethod === PurchaseMethodsConstantV25.FINANCE
        );

        const currentButton = !this.props.hasCustomButton && (
            <PaymentBar
                setMobilePaymentCalculatorOpened={this.props.handleFrequenciesPanel}
                selectedFinanceTerm={purchaseMethods.getSelectedFinanceTerm()}
                paymentFrequencyLabels={purchaseMethods.getPaymentFrequencyLabels(LocaleService)}
                taxesIncluded={purchaseMethods.taxesIncluded}
                taxCodes={purchaseMethods.taxCodes}
                frequenciesPanelOpen={this.props.frequenciesPanelOpen}
                config={this.props.config}
                displayCreditRate={this.props.displayCreditRate}
                hasAdobeTagging={this.props.hasAdobeTagging}
            />
        );

        return (
            <div>
                {currentButton}
                <div
                    className={this.props.panelFrequenciesClassNames.join(' ')}
                    ref={(calculator) => {
                        this.calculator = calculator;
                    }}
                >
                    <PurchaseMethodsTabControlHeader
                        leaseAvailable={calculatorLeaseOptionsAvailable}
                        financeAvailable={calculatorFinanceOptionsAvailable}
                        leaseSelected={purchaseMethods.isLease()}
                        financeSelected={purchaseMethods.isFinance()}
                        cashPurchaseSelected={purchaseMethods.isCashPurchase()}
                        selectPurchaseMethod={(selectedPurchaseMethod) =>
                            this.selectPurchaseMethod(selectedPurchaseMethod)
                        }
                    />
                    <PaymentCalculatorDetails
                        cashPurchaseSelected={purchaseMethods.isCashPurchase()}
                        closePanel={this.props.handleFrequenciesPanel}
                        config={this.props.config}
                        displayCreditRate={this.props.displayCreditRate}
                    />
                </div>
            </div>
        );
    }
}

PaymentCalculatorDisplay.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethodsV25.PurchaseMethodsModelV25).isRequired,
    paymentOptionsMetadata: PropTypes.instanceOf(PaymentOptionsMetadata.PaymentOptionsMetadataModel).isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModelV25).isRequired,
    handleFrequenciesPanel: PropTypes.func.isRequired,
    actions: PropTypes.shape({
        selectPurchaseMethod: PropTypes.func.isRequired,
        saveTradeInVehicle: PropTypes.func.isRequired,
    }),
    panelFrequenciesClassNames: PropTypes.arrayOf(PropTypes.string),
    frequenciesPanelOpen: PropTypes.bool.isRequired,
    hasCustomButton: PropTypes.bool.isRequired,
    hasAdobeTagging: PropTypes.bool,
    vehicle: PropTypes.instanceOf(Vehicle.VehicleModelV25),
    displayCreditRate: PropTypes.bool,
};

PaymentCalculatorDisplay.defaultProps = {
    actions: [],
    panelFrequenciesClassNames: [],
    hasAdobeTagging: false,
    vehicle: new Vehicle.VehicleModelV25(),
    displayCreditRate: false,
};

PaymentCalculatorDisplay.displayName = 'PaymentCalculatorDisplay';

function mapStateToProps(state) {
    return {
        purchaseMethods: state.purchaseMethodsV25,
        paymentOptionsMetadata: state.paymentOptionsMetadata,
        quote: state.quoteV25,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export { PaymentCalculatorDisplay };
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentCalculatorDisplay);
